export * from "./header";
export * from "./types";

export enum ROUTES {
  DASHBOARD = "/",
  LOGIN = "/login",
  SIGN_UP = "/signup",
  TRANSACTIONS = "/transactions",
  PROFILE = "/profile",
}
